module.exports = __webpack_public_path__ + "static/media/linkedin.56ab2348.png";